import { SortOption } from '@components/stock-list-heading/interfaces';
import { PortfoliosSortByOptions, StocksSortByOptions } from '@components/upgraded-stock-list-component/interfaces/sort-by-options.enum';
import { environment } from '../../environments/environment';

export const maxPointsOccurrences = 200;
export const maxRiskLevel = 10;
export const defaultAnswersRadioGroup = [
    {
        statement: 'Sí',
        value: true,
    },
    {
        statement: 'No',
        value: false,
    },
];
export const otherWorkerType = '3';
export const studentWorkerType = '4';
export const independentWorkerType = '2';
export const dependentWorkerType = '1';
export const marriedMaritalStatus = '3';
export const partnerMaritalStatus = '5';
export const totalSeparationOfPropertyRegime = '1';
export const maritalPartnershipRegime = '2';
export const profitSharingRegime = '3';
export const propertyCommunityRegime = '5';
export const separationOfPropertyRegime = '6';
export const femaleGenderValue = 'F';
export const pendingMovementStatus = 'pending';
export const USD_NEMO = 'USD';
export const CASH_NEMO = 'CASH';
export const CASH_PERCENTAGE = 0.005;
export const MIN_DW_DEPOSIT_AMOUNT = 1000; // for redistributions
export const MIN_USD_DW_INVESTMENT = 5;
export const MIN_USD_WITHDRAWAL = 5;
export const MIN_CLP_WITHDRAWAL = 5000;
export const MIN_USD_ASSET_THRESHOLD = 0.005;
export const DRIVEWEALTH_PORTFOLIO_NAME = 'Mis Stocks';
export const RUT_EXTENDED_FORM_FIELDS = ['rut', 'spouseRut', 'employerRut'];
export const TWO_WORDS_REGEX = '\\S+\\s{1}\\S.*';
export const EMAIL_REGEX = new RegExp(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,63}$/);
export const ACCOUNT_MANAGER_SCOPE = 'token';
export const ACCOUNT_TYPE = environment.production ? 'cl.racional.app' : 'cl.kunder.racional.dev';
export const ACCOUNT_MANAGER_GROUP_ID = 'Y834BZ2VWD.' + ACCOUNT_TYPE;
export const MIN_INITIAL_INVESTMENT = 5000;
export const MIN_MONTHLY_INVESTMENT = 5000;
export const SHORT_LIST_MAX_MOVEMENTS = 5;
export const REFERRAL_RETAINED_DAYS = 90;
export const READS_FETCH_LIMIT = 3;
export const AVATARS = [
  'assets/icon/animal-1.png',
  'assets/icon/animal-2.png',
  'assets/icon/animal-3.png',
  'assets/icon/animal-4.png',
  'assets/icon/animal-5.png',
  'assets/icon/animal-6.png',
  'assets/icon/animal-7.png',
  'assets/icon/animal-8.png',
  'assets/icon/animal-9.png',
  'assets/icon/animal-10.png',
  'assets/icon/animal-11.png',
  'assets/icon/animal-12.png',
];
export const OBJECTIVE_IMG_MAP = {
  0: 'obj-viajar',
  1: 'obj-vivienda',
  2: 'obj-emergencias',
  3: 'obj-estudios',
  4: 'obj-generales',
  5: 'obj-pension',
  6: 'obj-children',
  7: 'obj-dap',
};
export const OBJECTIVE_NAME_MAP = {
  0: 'Viajar',
  1: 'Vivienda',
  2: 'Emergencias',
  3: 'Estudios',
  4: 'Generales',
  5: 'Pensión',
  6: 'Hijos',
  7: 'Depósito a Plazo',
};
export const CHILD_ICON_IMG_MAP = [
  'obj-hijo',
  'obj-hija',
  'baby',
  'stroller',
];
export const SECONDS = 1000;
export const MINUTES = 60 * SECONDS;
export const SHORT_WEEKDAYS = ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'];
export const WEEKDAYS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
export const SHORT_MONTHS = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];
export const MONTHS = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
];
export const PASSIVE_MOVEMENT_LABEL = {
  dividends: 'Dividendo',
  commissions: 'Comisión',
  interests: 'Intereses',
  corporateEvents: 'Evento Corporativo',
};
export const CORPORATE_EVENT_TYPE_LABELS = {
  SPLIT: 'División de acciones',
  MERGER: 'Fusión y Adquisición',
  SPINOFF: 'Spin-off',
};
export const CASH_MODAL_PROPS = {
  information: {
    title: 'Caja',
    content: [{
      content: [
        'Tu portafolio debe tener un pequeño porcentaje en caja para cubrir las ' +
        'comisiones asociadas a tus inversiones.',
        'En cierto sentido, es similar a tener dinero en tu cuenta bancaria, ' +
        'pero en tu cuenta de inversiones.',
        'El dinero en caja no está invertido, pero tampoco está sujeto a comisiones.',
        'Para reinvertir automáticamente todo el exceso de caja que tengas cada vez que ' +
        'deposites, activa la funcionalidad de la Reinversión de la caja en tu Perfil.',
      ],
    }],
  },
  paragraph: true,
};

export const orderTypesES = {
  'MARKET': 'Mercado',
  'STOP': 'Stop',
  'LIMIT': 'Límite',
  'MARKET_IF_TOUCHED': 'Market if Touched',
};

export const orderTypesShortES = {
  'MARKET': 'mercado',
  'STOP': 'Stop',
  'LIMIT': 'Límite',
  'MARKET_IF_TOUCHED': 'MIT',
};

export const orderTypesPriceES = {
  'MARKET': 'Mercado',
  'STOP': 'Stop',
  'LIMIT': 'Límite',
  'MARKET_IF_TOUCHED': 'de activación',
};

export const orderTypesShortEN = {
  'MARKET': 'market',
  'STOP': 'stop',
  'LIMIT': 'limit',
  'MARKET_IF_TOUCHED': 'mit',
};

export const RANKING_SHARD_SIZE = 50;
export const RANKING_LOAD_SIZE = 10;
export const NY_TIMEZONE = 'America/New_York';
export const SMARTLINK_BANNER_DAYS = 10;
export const SMARTLINK_BANNER_IN_HOME_DAYS = 3;
export const SMARTLINK_EXPIRED_BANNER_DAYS = 30;
export const DAP_TICKER = 'CFIETFCD';
export const EMERGENCY_PORTFOLIO_OBJECTIVE = 2;
export const GENERAL_INVESTMENTS_PORTFOLIO_OBJECTIVE = 4;
export const DAP_PORTFOLIO_OBJECTIVE = 7;
export const DAP_PORTFOLIO_NAME = 'Depósito a Plazo';
export const DAP_PORTFOLIO_LABEL_TITLE = 'Comisión 0%';
export const TAXES_REPORTS_NAMES_MAP = {
  taxesReports: 'impuestos',
  operationsReports: 'operaciones',
};

export namespace StocksBoost {
  export enum Banner {
    ShowAfterEstablishedDays = 15,
    MaxClosedTimes = 4,
    ShowAfterDisableDays = 30,
  }

  export enum Modal {
    MaxClosedTimes = 10,
  }
}

export namespace TaxTreatyWithUS {
  export enum Modal {
    MaxClosedTimes = 10,
  }
}

export namespace W8RenovationModal {
  export enum Modal {
    MaxClosedTimes = 10,
  }
}

const ONE_MILLION = 1000000;
export enum TransfersConstants {
  TRANSFER_CREATION_SAME_DAY_LIMIT_HOUR = 10,
  TRANSFER_CREATION_LIMIT_HOUR = 13,
  TRANSFER_CREATION_LIMIT_MINUTES = 50,
  TRANSFER_CREATION_USD_LIMIT_HOUR = 20,
  TRANSFER_CREATION_USD_LIMIT_MINUTES = 0,
  TRANSFER_CREATION_PORTFOLIOS_LIMIT_HOUR = 11,
  TRANSFER_CREATION_PORTFOLIOS_LIMIT_MINUTES = 50,
  SMALL_AMOUNT_TRANSFER_MINUTES = 15,
  LIMIT_TRANSFER_AMOUNT = ONE_MILLION,
}
export enum TransfersTimes {
  MINIMUM_TRANSFER_TIME_HOUR = 10,
  MINIMUM_TRANSFER_TIME_MINUTE = 30,
  LIMIT_TRANSFER_HOUR = 18,
  LIMIT_TRANSFER_MINUTES = 0,
  MAX_TRANSFER_USD_TIME_HOUR = 13,
  MAX_TRANSFER_USD_TIME_MINUTES = 30,
}
export enum TransferTypes {
  TRANSFER_BETWEEN_PORTFOLIOS = 'portfolioToPortfolio',
  TRANSFER_FROM_PORTFOLIO_TO_STOCKS = 'portfolioToStocks',
  TRANSFER_FROM_STOCKS_TO_PORTFOLIO = 'stocksToPortfolio',
}
export const UINT32_MAX = 0xffffffff;
export const PORTFOLIO_FUNDS_RECEPTION_DAYS = 2;
export enum PortfoliosOrdersSendTime {
  HOUR = 11,
  MINUTES = 50,
}

export const TRANSPARENT_PIXEL = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
export const FRACTIONAL_SHARES_PATTERN = '^[0-9]+(\.[0-9]+)?$';
export const INTEGER_SHARES_PATTERN = '^[0-9]*$';
export const DRIVEWEALTH_MIN_FRACTIONAL_SHARES_AMOUNT = 0.00000001;
export enum Currencies {
  USD = 'USD',
  CLP = 'CLP',
}
export const CURRENCY_PREFIX = {
  [Currencies.USD]: 'US$',
  [Currencies.CLP]: '$',
};
export const CURRENCY_DECIMALS = {
  [Currencies.USD]: '1.2-2',
  [Currencies.CLP]: '1.0-0',
};
export const CURRENCY_LOCALE = {
  [Currencies.USD]: 'en',
  [Currencies.CLP]: 'es',
};

export const RESTRICTED_PORTFOLIO_NAME = 'Portafolios con mis pesos';

export const STOCKS_BOOST_ACTIVATION = {
  ERROR: 'Debes tener más de US$250 invertido en Stocks para activar Stocks Boost.',
  SUCCESS: '¡Stocks Boost activado! Los intereses mensuales llegarán a tu Billetera de forma automática.',
};

export const MIN_REFERRAL_INVESTMENT = 100_000;
export const DEFAULT_VISIBLE_STOCKS_COUNT = 5;
export const RELATED_STOCKS_LIMIT = 10;

export const ZERO_RETURN_THRESHOLD = 0.0005;
export const NEGATIVE_RETURN_THRESHOLD = -0.005;
export const ZERO_RETURNS = 0;

const amountLabel = 'Valor Inversión';
const amountUSDLabel = 'Valor Inversión';
const weightLabel = 'Distribución (%)';
const sharePriceOriginalCurrencyLabel = 'Último Precio';
const unrealizedPLLabelUSD = 'Ganancia Total';
const unrealizedPLLabel = 'Ganancia Total';
const unrealizedPLPercentLabel = 'Ganancia Total (%)';
const unrealized12MPLLabel = 'Ganancia 12M';
const unrealized12MPLPercentLabel = 'Ganancia 12M (%)';
const unrealized1MPLLabel = 'Ganancia 1M';
const unrealized1MPLPercentLabel = 'Ganancia 1M (%)';
const unrealizedDayPLLabelUSD = 'Ganancia Hoy';
const unrealizedDayPLLabel = 'Ganancia Hoy';
const unrealizedDayPLPercentLabel = 'Ganancia Hoy (%)';
export const AMOUNT_OF_SHARES_LABEL = 'Acciones';

export const STOCKS_SORT_OPTIONS_HIDDEN_TOTAL_AMOUNTS = [
  'sharePriceOriginalCurrency',
  'unrealizedPLPercent',
  'unrealizedDayPLPercent',
  'weight',
];
export const PORTFOLIOS_SORT_OPTIONS_HIDDEN_TOTAL_AMOUNTS = [
  'unrealizedPLPercent',
  'unrealized12MPLPercent',
  'unrealized1MPLPercent',
  'unrealizedDayPLPercent',
];

export const STOCKS_SORT_OPTIONS: SortOption[] = [
  { label: unrealizedPLLabelUSD, value: StocksSortByOptions.UNREALIZED_PL },
  { label: unrealizedPLPercentLabel, value: StocksSortByOptions.UNREALIZED_PL_PERCENT },
  { label: unrealizedDayPLLabelUSD, value: StocksSortByOptions.UNREALIZED_DAY_PL },
  { label: unrealizedDayPLPercentLabel, value: StocksSortByOptions.UNREALIZED_DAY_PL_PERCENT },
  { label: amountUSDLabel, value: StocksSortByOptions.AMOUNT_USD },
  { label: weightLabel, value: StocksSortByOptions.WEIGHT },
  { label: sharePriceOriginalCurrencyLabel, value: StocksSortByOptions.LAST_PRICE },
  { label: AMOUNT_OF_SHARES_LABEL, value: StocksSortByOptions.AMOUNT_OF_SHARES },
];

export const PORTFOLIOS_SORT_OPTIONS: SortOption[] = [
  { label: amountLabel, value: PortfoliosSortByOptions.AMOUNT },
  { label: unrealizedPLPercentLabel, value: PortfoliosSortByOptions.UNREALIZED_PL_PERCENT },
  { label: unrealizedPLLabel, value: PortfoliosSortByOptions.UNREALIZED_PL },
  { label: unrealized12MPLPercentLabel, value: PortfoliosSortByOptions.UNREALIZED_12M_PL_PERCENT },
  { label: unrealized12MPLLabel, value: PortfoliosSortByOptions.UNREALIZED_12M_PL },
  { label: unrealized1MPLPercentLabel, value: PortfoliosSortByOptions.UNREALIZED_1M_PL_PERCENT },
  { label: unrealized1MPLLabel, value: PortfoliosSortByOptions.UNREALIZED_1M_PL },
  { label: unrealizedDayPLPercentLabel, value: PortfoliosSortByOptions.UNREALIZED_DAY_PL_PERCENT },
  { label: unrealizedDayPLLabel, value: PortfoliosSortByOptions.UNREALIZED_DAY_PL },
];

export const PORTFOLIOS_SORTING_CONFIG = {
  [PortfoliosSortByOptions.AMOUNT]: {
    property: 'totalAmount',
    period: 'allTime',
    isTotal: true,
  },
  [PortfoliosSortByOptions.UNREALIZED_PL_PERCENT]: {
    property: 'allTimeProfitPercentage',
    period: 'allTime',
    isTotal: false,
  },
  [PortfoliosSortByOptions.UNREALIZED_PL]: {
    property: 'allTimeProfitAmount',
    period: 'allTime',
    isTotal: false,
  },
  [PortfoliosSortByOptions.UNREALIZED_12M_PL_PERCENT]: {
    property: 'yearProfitPercentage',
    period: 'year',
    isTotal: false,
  },
  [PortfoliosSortByOptions.UNREALIZED_12M_PL]: {
    property: 'yearProfitAmount',
    period: 'year',
    isTotal: false,
  },
  [PortfoliosSortByOptions.UNREALIZED_1M_PL_PERCENT]: {
    property: 'monthProfitPercentage',
    period: 'month',
    isTotal: false,
  },
  [PortfoliosSortByOptions.UNREALIZED_1M_PL]: {
    property: 'monthProfitAmount',
    period: 'month',
    isTotal: false,
  },
  [PortfoliosSortByOptions.UNREALIZED_DAY_PL_PERCENT]: {
    property: 'dailyProfitPercentage',
    period: 'daily',
    isTotal: false,
  },
  [PortfoliosSortByOptions.UNREALIZED_DAY_PL]: {
    property: 'dailyProfitAmount',
    period: 'daily',
    isTotal: false,
  },
};

export const PERIOD_TO_SORT_BY_CONFIG = {
  allTime: {
    withValues: PortfoliosSortByOptions.UNREALIZED_PL,
    withoutValues: PortfoliosSortByOptions.UNREALIZED_PL_PERCENT,
  },
  year: {
    withValues: PortfoliosSortByOptions.UNREALIZED_12M_PL,
    withoutValues: PortfoliosSortByOptions.UNREALIZED_12M_PL_PERCENT,
  },
  month: {
    withValues: PortfoliosSortByOptions.UNREALIZED_1M_PL,
    withoutValues: PortfoliosSortByOptions.UNREALIZED_1M_PL_PERCENT,
  },
  daily: {
    withValues: PortfoliosSortByOptions.UNREALIZED_DAY_PL,
    withoutValues: PortfoliosSortByOptions.UNREALIZED_DAY_PL_PERCENT,
  },
};

export const MOBILE_BREAKPOINT = 480;
export const TABLET_BREAKPOINT = 768;
export const MIN_REFRESH_INTERVAL_MS = 5000;

export const PUBLIC_URLS = ['/read/', '/themes/'];
export enum MFAMethods {
  Email = 'email',
}
